import { render, staticRenderFns } from "./ProductConfiguratorDialog.vue?vue&type=template&id=1672508b"
import script from "./ProductConfiguratorDialog.vue?vue&type=script&lang=ts"
export * from "./ProductConfiguratorDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports